import React, { useEffect, useState, useRef, useContext } from 'react';
import { Toast } from 'primereact/toast';
import Form from 'react-bootstrap/Form';
import './help.css'
import { BreadCrumb } from 'primereact/breadcrumb';
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
// import MapIcon from '../../assets/icons/map.svg';
import { Dialog } from 'primereact/dialog';
import { Divider } from 'primereact/divider';
import MapComponent from '../MapComponent';
import { getHelp,GetContact } from '../../utils/api';
import moment from 'jalali-moment';
import Loadr from '../loader/loader';
import LoaderPage from '../loader/dotloader';
import { Accordion } from 'react-bootstrap'
import useToastNotification from '../../hooks/useToastNotification';
//icon
import Email from '../../assets/icons/contact/email.svg'
import Phone from '../../assets/icons/contact/phone.svg'
import Instagram from '../../assets/icons/contact/instagram.svg'

function Profile() { // Receive onProfileLoad as a prop
    const [loading, setLoading] = useState(false);
    const [visible, setVisible] = useState(false);
    const [help, setHelp] = useState([]);
    const { showError, showSuccess } = useToastNotification();

    const fetchHelp = async () => {
        try {
            setLoading(true)
            let res = await getHelp()
            if (res.data != null) {
                setHelp(res.data)
                setLoading(false)
            } else {
                setLoading(false)
            }

        } catch (error) {
            showError('خطا در برقرای ارتباط...')

        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        fetchHelp()
        
    }, [])


    const removeHtmlTags = (htmlString) => {
        const doc = new DOMParser().parseFromString(htmlString, 'text/html');
        return doc.body.textContent || doc.body.innerText || "";
    };

    const [contactList, setContactList] = useState(false)

    const getContactData = async () => {
        console.log('.....')
        try {
            let data = await GetContact()
            if(data.data != null){
                setContactList(data.data)
                setVisible(true)

            }

        } catch (error) {

        } finally {
            setLoading(false)
        }
    }

 
    return (
        <>
            {loading && <LoaderPage isLoading={loading} />}

            <div className='profile-card'>
                <h6 className='page-title mb-4 mt-3'>راهنما</h6>
                <div className='row help-section mx-auto gy-3'>
                    {
                        help.length > 0 && help.map((item, index) => (
                            <div className='col-12 col-md-6 col-lg-4' key={index}>
                                <div className='help-card'>
                                    <img src={item.Pic} alt="" />
                                    <h5 className='mt-3'>{removeHtmlTags(item.Titr)}</h5>
                                    <p>{removeHtmlTags(item.Matn)}</p>
                                </div>

                            </div>

                        ))
                    }
                </div>
                <div className='w-100 text-center mt-3'>
                    <button className='btn btn-primary mx-auto' onClick={() =>  getContactData()}>نیاز به راهنمایی دارید؟</button>

                </div>
            </div>
            <Dialog draggable={false} header="تماس با ما" className="custom-dialog dialog-contact" visible={visible} maximizable onHide={() => setVisible(false)}>
                <div className="contact-item mx-auto mt-5 ">
                 
                    <a className="item" href={`mailto:${contactList.email}`}>
                        <div className="img-box">
                            <img src={Email} alt="" />
                        </div>
                        <h6 className="text-[#00a14b] text-lg font-bold">{contactList.email}</h6>

                    </a>
                    <a className="item" href={contactList.insta} target='_blank'>
                        <div className="img-box">
                            <img src={Instagram} alt="" />
                        </div>
                        <h6 className="text-[#00a14b] text-lg font-bold">benicejuice</h6>

                    </a>
                    <a className="item" href={`tel:${contactList.phone}`}>
                        <div className="img-box">
                            <img src={Phone} alt="" />
                        </div>
                        <h6 className="text-[#00a14b] text-lg font-bold">{contactList.phone}</h6>

                    </a>

                </div>
            </Dialog>
        </>
    );
}

export default Profile;
